import { get } from './rest';

const rootUrl = `${process.env.API_URL}/categories`;

export default {
	get: () => get(`${rootUrl}`)
	// delete: id => del(`${rootUrl}/${id}`)
};
